<template>
  <div class="course-list-container">
    <div class="grade-class">
      <van-field
        :value="value"
        readonly
        clickable
        label="当前班级"
        placeholder="请选择班级"
        @click="showPicker = true"/>
      <van-button type="info" class="logout" @click="logout">退出</van-button>
    </div>
    <div class="list-container">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了">
        <div class="list" v-for="(item, index) in list" :key="index">
          <div class="item-header">
            <div class='title-text'>
              <div class='title-icon'/>
              <span>第{{index + 1}}课</span>
            </div>
            <span v-if="item.startCourseTime">开课时间：{{item.startCourseTime}}</span>
          </div>
          <div class="list-item">
            <div class="item-left">
              <img mode='aspectFit' :src="item.bookPic | thumbnailImg" class='book-pic'/>
            </div>
            <div class="item-right">
              <div class="item-top">
                <span class="book-theme">{{item.readTopicName}}</span>
                <span class='book-title'>{{item.courseTitle}}</span>
                <span class="book-desc">{{item.keyWords}}</span>
              </div>
              <div class="item-bottom">
                <span class="btn"><router-link :to="{ path:'/courseIntroduce?id=' + item.bookCoursewareId }" target="_blank" style="color: #00C553;">课程介绍</router-link></span>
                <span v-if="item.pptUrl" class="btn"><router-link :to="{ path:'/coursePPT?url=' + item.pptUrl }" target="_blank" style="color: #00C553;">课件演示</router-link></span>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        :columns="columns"
        value-key="gcName"
        title="请选择班级"
        show-toolbar
        @confirm="onConfirm"
        @cancel="onCancel"/>
    </van-popup>
  </div>
</template>

<script>
import { api } from '@/api/index'
import { Picker, Popup, Field, List, Button} from 'vant'

export default {
  name: 'CourseList',
  components: {
    [Button.name]: Button,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [List.name]: List
  },
  data() {
    return {
      value: '',
      showPicker: false,
      loading: true,
      finished: false,
      columns: [],
      list: [],
      pickerItem: {}
    }
  },
  created() {
    this.getClassList()
  },
  methods: {
    getClassList() {
      api.getAllClassList({
        teacherId: this.$store.getters.accountInfo.teacherId
      }).then(res => {
        if (res.code === 10000) {
          this.columns = res.data
          this.value = res.data[0].gcName
          this.pickerItem = res.data[0]
          this.onLoad()
        } else {
          this.loading = false
          this.finished = true
          this.$toast.fail(res.message)
        }
      }).catch(err => {
        this.$toast.fail(err.message)
      })
    },
    onConfirm(item) {
      this.value = item.gcName
      this.showPicker = false
      this.pickerItem = item
      this.loading = true
      this.finished = false
      this.list = []
      this.onLoad()
    },
    onCancel() {
      this.showPicker = false
    },
    onLoad() {
      api.getCourseList({
        schoolId: this.$store.getters.accountInfo.schoolId,
        teacherId: this.$store.getters.accountInfo.teacherId,
        classId: this.pickerItem.classId
      }).then(res => {
        this.loading = false
        this.finished = true
        if (res.code === 10000) {
          this.list = res.data.list
        } else {
          this.$toast.fail(res.message)
        }
      })
    },
    logout() {
      this.$dialog.confirm({
        title: '提示',
        message: '确认退出当前账号？',
      }).then(() => {
        // localStorage.removeItem('vuex')
        this.$store.dispatch('FedLogOut').then(() => {
          this.$router.push('/QrLogin')
        })
      }).catch(() => {
        console.log('我取消了')
      })
    }
  }
}
</script>

<style scoped>
.course-list-container {
  position: relative;
  min-width: 320px;
}

.logout{
  position: absolute;
  height: 30px;
  top: 10px;
  right: 10px;
  z-index: 99999;
}

.van-cell::after {
  border: 0;
}

.grade-class {
  position: fixed;
  width: 100%;
  height: 50px;
  background-color: #fff;
  font-size: 18px;
  text-align: center;
  line-height: 50px;
  top: 0;
  left: 0;
  z-index: 999;
}

.list-container {
  position: relative;
  max-width: 414px;
  margin: 60px auto 30px;
  padding: 0 15px;
  box-sizing: border-box;
}

.list {
  position: relative;
  width: 100%;
  background-color: #fff;
  border-radius: 8px;
  margin: 0 auto 30px;
  box-shadow: 0 0 5px rgba(0, 0, 0, .2);
}

.item-header {
  position: relative;
  width: 100%;
  height: 50px;
  line-height: 50px;
  padding: 0 10px;
  box-sizing: border-box;
  font-size: 14px;
  color: #999;
  border-bottom: 1px solid #EAEAEA;
}

.title-text {
  display: inline-block;
  margin: 0 10px 0 25px;
  color: #000;
  font-weight: 700;
  font-size: 16px;
}

.title-icon {
  position: absolute;
  top: 50%;
  left: 20px;
  transform: translateY(-50%);
  width: 4px;
  height: 20px;
  border-radius: 2px;
  background-color: #00c553;
}

.list-item {
  position: relative;
  width: 100%;
  height: 170px;
}

.item-left {
  position: absolute;
  width: 35%;
  height: 100%;
  top: 0;
  left: 0;
  overflow: hidden;
}

.book-pic {
  max-width: 100px;
  max-height: 130px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 8px;
}

.item-right {
  position: absolute;
  width: 65%;
  height: 100%;
  top: 0;
  right: 0;
}

.item-top {
  position: absolute;
  width: 100%;
  height: 70%;
  top: 0;
  left: 0;
}

.item-bottom {
  position: absolute;
  width: 100%;
  height: 30%;
  bottom: 0;
  left: 0;
  text-align: right;
}

.book-theme {
  position: absolute;
  width: 40px;
  height: 20px;
  line-height: 20px;
  border-radius: 4px;
  text-align: center;
  left: 5px;
  top: 27px;
  font-size: 13px;
  color: #fff;
  background-color: #AF8FFE;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.book-title {
  position: absolute;
  width: 70%;
  left: 55px;
  top: 27px;
  font-size: 16px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.book-desc {
  position: absolute;
  width: 90%;
  left: 5px;
  top: 65px;
  font-size: 13px;
  color: #838383;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
}

.btn {
  display: inline-block;
  width: 70px;
  height: 26px;
  font-size: 12px;
  text-align: center;
  line-height: 26px;
  border-radius: 13px;
  color: #00C553;
  background-color: #fff;
  border: 1px solid #00C553;
  margin-right: 10px;
  cursor: pointer;
}
</style>